import { styled } from './../../styles/theme.config.js';

export const Container = styled('div', {
    padding : '5em 5em',
    flexDirection : 'column',
    justifyContent : 'center',
    display : 'none',
    "@media only screen and (max-width : 600px)": {
        display : 'flex',
        padding : '0em 3em'
    },
})

export const Header = styled('h2', {
    textAlign : 'center',
    margin : '0.5em',
})

export const Image = styled('img',{
    width: '180px',
    display: 'block',
    margin: 'auto',
    padding : '0em',
    borderRadius : '3px',
    "@media only screen and (max-width : 600px)": {
        width : '85vw'
    },
})

export const Content = styled('div',{
    border : 'none !important',
    margin : '0em 0',
    padding : 0,
})

export const Box = styled('div', {
    display : 'flex',
    flexWrap : 'wrap',
    width : '100%',
    justifyContent : 'center',
    margin : '0 auto',
})

export const Product = styled('img', {
    width : '200px',
    margin : '1em',
})

export const Link = styled('a', {
    textDecoration : 'none',
})